module.exports = __webpack_public_path__ + "img/everton.e4d07205.png";